import type { RequestQueryOptions } from '@entities/lesson/model/types/api'

import { confirmEmailVerification, requestEmailVerification } from './email-verification'
import { requestPhoneOtp, validatePhoneOtp } from './phone-otp'
import { updateProfile, UpdateProfileBody } from './update-profile'
import { userEntityQueries } from './user.query'

export const userEntityMutations = {
  updateProfile: ({ bearerToken }: RequestQueryOptions) => ({
    mutationKey: [...userEntityQueries.all, 'updateProfile', bearerToken],
    mutationFn: (body: UpdateProfileBody) => updateProfile(body, bearerToken),
  }),

  requestPhoneOtp: ({ bearerToken }: RequestQueryOptions) => ({
    mutationKey: [...userEntityQueries.all, 'requestPhoneOtp', bearerToken],
    mutationFn: (phone: string) => requestPhoneOtp(phone, bearerToken),
  }),

  validatePhoneOtp: ({ bearerToken }: RequestQueryOptions) => ({
    mutationKey: [...userEntityQueries.all, 'validatePhoneOtp', bearerToken],
    mutationFn: ({ phone, otp }: { phone: string; otp: string }) => validatePhoneOtp(phone, otp, bearerToken),
  }),

  requestEmailVerification: ({ bearerToken }: RequestQueryOptions) => ({
    mutationKey: [...userEntityQueries.all, 'requestEmailVerification', bearerToken],
    mutationFn: (email: string) => requestEmailVerification(email, bearerToken),
  }),

  confirmEmailVerification: ({ bearerToken }: RequestQueryOptions) => ({
    mutationKey: [...userEntityQueries.all, 'confirmEmailVerification', bearerToken],
    mutationFn: ({ email, code }: { email: string; code: string }) =>
      confirmEmailVerification(email, code, bearerToken),
  }),
} as const
